import { memo } from 'react';
import { Dialog } from 'react-aria-components';

import { BasicModal, ModalOverlayProps } from '@/components/core';

import { UpgradePlan, UpgradePlanProps } from './UpgradePlan';

export type UpgradePlanModalProps = ModalOverlayProps & UpgradePlanProps;

const IUpgradePlanModal = ({
  monthlyPlanId,
  yearlyPlanId,
  defaultPlanId,
  isOpen,
  getPaymentMethodPromise,
  close,
}: UpgradePlanModalProps) => {
  return (
    <BasicModal isOpen={isOpen} onDismiss={() => close?.()}>
      <Dialog className="outline-none">
        {({ close: uncontrolledClose }) => (
          <UpgradePlan
            className="w-[60rem]"
            monthlyPlanId={monthlyPlanId}
            yearlyPlanId={yearlyPlanId}
            defaultPlanId={defaultPlanId}
            getPaymentMethodPromise={getPaymentMethodPromise}
            close={() => {
              close?.();
              uncontrolledClose();
            }}
          />
        )}
      </Dialog>
    </BasicModal>
  );
};

export const UpgradePlanModal = memo(IUpgradePlanModal) as typeof IUpgradePlanModal;
